export default __webpack_public_path__ + "static/media/135.8900d156.gif";